<div *ngIf="esNumerada">
  {{ esNumerada }}
  <div class="backModal enMotivo" *ngIf="butacaMarcada">
    <div class="close closeModal">
      <a (click)="close()" title="{{ 'CERRAR' | translate }}"
        ><span class="cross"></span><span class="sr-only">{{ 'CERRAR' | translate }}</span></a
      >
    </div>
    <div class="aviso">
      <div class="MotivosModalLayout">
        <div class="MotivosModalLeft">
          <div class="ticket-info horarios-info">
            <div class="inputControl TicketsPasos">
              <span class="titulo"
                >
                {{ 'TARIFAS_DISPONIBLES_LOCALIDAD_FILA' | translate }}
                {{ ' ' }}
                {{ butacaMarcada.dataNumFila }} {{ 'NUMERO' | translate }}
                {{ butacaMarcada.dataNumButaca }} -
                {{ espectaculoSeleccionado.chNombreEspectaculo }}
                {{ diaHoraSeleccionado }}</span
              >
            </div>
          </div>
          <div class="motivosWrap">
            <div class="motivos">
              <div
                *ngFor="
                  let tarifa of butacaMarcada.info.tiposDeEntrada;
                  let i = index
                "
              >
                <div (click)="marcarTarifa(i)" [class]="claseTarifa(i)">
                  <div class="Rtable-cell--content motivo-content">
                    {{ tarifa.NombreEntrada }}
                  </div>
                  <div class="Rtable-cell--content entrada-precio">
                    <strong
                      >{{
                        conversor(tarifa.PrecioInternet) +
                          conversor(tarifa.Comision)
                          | myCurrency : divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles
                      }}
                    </strong>
                  </div>
                  <input
                    style="visibility: hidden; display: none"
                    type="number"
                    class="qty text"
                    step="1"
                    min="0"
                    name="quantity"
                    category="MOTIVO"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!esNumerada">
  <div class="backModal enMotivo" *ngIf="butacaMarcada">
    <div class="close closeModal">
      <a (click)="close()" title="{{ 'CERRAR' | translate }}"
        ><span class="cross"></span><span class="sr-only">{{ 'CERRAR' | translate }}</span></a
      >
    </div>
    <div class="aviso">
      <div class="MotivosModalLayout">
        <div class="MotivosModalLeft">
          <div class="ticket-info horarios-info">
            <div class="inputControl TicketsPasos">
              <span class="titulo"
                >
                {{ 'TARIFAS_DISPONIBLES_PARA' | translate }}
                {{ ' ' }}
                {{ butacaMarcada.info.infoGeneral.nombreRecinto }}</span
              >
            </div>
          </div>
          <section class="col-seleccion">
            <div class="wrap-tabs-seleccion">
              <div id="tabs-content">
                <div id="tabSel-01">
                  <div class="Rtable">
                    <div class="Rtable-row Rtable-row--head">
                      <div class="Rtable-cell item-cell column-heading">
                        {{ 'ITEM' | translate }}
                      </div>
                      <div class="Rtable-cell precio-cell column-heading">
                        {{ 'PRECIO' | translate }}
                      </div>
                      <div class="Rtable-cell cantidad-cell column-heading">
                        {{ 'CANTIDAD' | translate }}
                      </div>
                    </div>
                    <div class="listado">
                      <div>
                        <div *ngFor="let tarifa of pagedItems; let i = index">
                          <div [class]="claseTarifaNoNumerada(i)">
                            <div class="Rtable-cell item-cell">
                              <div [class]="claseTarifaNoNumeradaTexto(i)">
                                {{ tarifa.NombreEntrada }} - Tipo:
                                {{ tarifa.DescripcionTipo }}
                              </div>
                            </div>
                            <div class="Rtable-cell precio-cell">
                              <div [class]="claseTarifaNoNumeradaPrecio(i)">
                                {{
                                  conversor(tarifa.PrecioInternet) +
                                    conversor(tarifa.Comision)
                                    | myCurrency : divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles
                                }}
                              </div>
                            </div>
                            <div
                              class="Rtable-cell Rtable-cell--foot cantidad-cell"
                            >
                              <div
                                class="Rtable-cell--content cantidad-content"
                              >
                                <div class="quantity">
                                  <button
                                    [disabled]="!permiteMarcar"
                                    type="button"
                                    value="-"
                                    [class]="claseTarifaNoNumeradaMinus(i)"
                                    (click)="
                                      restaCantidadNoNumerada(
                                        tarifa,
                                        i,
                                        butacaMarcada.dataIdRecinto
                                      )
                                    "
                                  >
                                    -
                                  </button>
                                  <input
                                    id="{{ tarifa.idTarifa }}"
                                    type="number"
                                    [class]="claseTarifaNoNumeradaCantidad(i)"
                                    step="1"
                                    min="0"
                                    name="quantity"
                                    category="CANTIDAD"
                                    [value]="tarifa.Cantidad"
                                    (focus)="focusValue($event, tarifa)"
                                    (blur)="unfocusValue($event)"
                                    (keydown)="inputDeTeclado($event, tarifa)"
                                    title="Cantidad"
                                    size="4"
                                  />
                                  <button
                                    [disabled]="!permiteMarcar"
                                    type="button"
                                    value="+"
                                    [class]="claseTarifaNoNumeradaPlus(i)"
                                    (click)="
                                      sumaCantidadNoNumerada(
                                        tarifa,
                                        i,
                                        butacaMarcada.dataIdRecinto
                                      )
                                    "
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <ul
                      class="pagination"
                      *ngIf="pager.pages && pager.pages.length > 1"
                    >
                      <li>
                        <a
                          (click)="setPage(pager.currentPage - 1)"
                          title="Previo"
                        >
                          <img
                            class="svg"
                            src="assets/img/active-arrow.svg"
                            alt="icono prev"
                          />
                        </a>
                      </li>
                      <li *ngFor="let page of pager.pages">
                        <a
                          (click)="setPage(page)"
                          [ngClass]="{ active: pager.currentPage === page }"
                          >{{ page }}</a
                        >
                      </li>
                      <li>
                        <a
                          (click)="setPage(pager.currentPage + 1)"
                          title="Próximo"
                        >
                          <img
                            class="svg"
                            src="assets/img/active-arrow.svg"
                            alt="icono next"
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="inputControl botones">
        <button
          [ngClass]="{ disabled: !tarifaSelected() }"
          type="button"
          value="{{ 'ACEPTAR' | translate }}"
          class="pagar aceptar"
          (click)="confirmarCierre()"
        >
          {{ 'ACEPTAR' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
